import { createToaster } from '@chakra-ui/react'

/**
 * Toast queue. Kept apart from the `<Toaster />` renderer so feature code can
 * raise notifications without importing a component.
 */
export const toaster = createToaster({
  placement: 'bottom-end',
  pauseOnPageIdle: true,
  duration: 5000,
})

export const notifySuccess = (title, description) =>
  toaster.create({ type: 'success', title, description, closable: true })

export const notifyError = (title, description) =>
  toaster.create({ type: 'error', title, description, closable: true })

/**
 * The write worked, but something about the result needs saying.
 *
 * Distinct from an error on purpose: reporting a successful save as a failure
 * teaches people to retry writes that already landed. Held longer than the
 * others because a warning is read rather than glanced at.
 */
export const notifyWarning = (title, description) =>
  toaster.create({ type: 'warning', title, description, closable: true, duration: 9000 })
